import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const QuestionTableInputAPI = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/read_exist_questionario`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'QuestionTableInputAPI');
    }
};

export const QuestionDelete = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/delete_cuttopic`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'QuestionDelete');
    }
};
